import React from "react";

import "./chrome.css";

/**
 * Ladeanzeige mit Spinner und zwei Zeilen Text.
 *
 * Zwei Auftritte, deshalb `inline`:
 * - fullscreen (default), waehrend src/index.js noch Daten und Fonts holt. Da
 *   gibt es noch keine Kopfzeile; die Anzeige loest die HTML-Vorlage aus
 *   public/index.html ab, ohne dass dazwischen etwas blitzt.
 * - inline in der PdfShell, waehrend react-pdf rendert. Dort steht die
 *   Kopfzeile schon, die Anzeige fuellt nur den Bereich unter ihr. Sonst
 *   springt das Layout, sobald das PDF fertig ist.
 */
const LoadingScreen = ({
  title = "Einen Moment ...",
  message = "Das Profil wird gerade erstellt und lädt gleich.",
  inline = false,
}) => {
  const variant = inline ? "aivy-loading--inline" : "aivy-loading--fullscreen";

  return (
    <div className={`aivy-loading ${variant}`}>
      <div className="aivy-loading__content">
        <div className="aivy-loading__spinner" />
        <h1 className="aivy-loading__title">{title}</h1>
        <p className="aivy-loading__message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
